<template>
  <div class="product" v-if="info.softwareSystemName">
    <div class="p-head">
      <div class="h-box">
        <div>
          <div class="img-mol">
            <el-carousel height="500px" arrow="never" indicator-position="outside" :autoplay="false" :loop="false">
              <el-carousel-item v-for="(o, i) in systemPhoto" :key="i">
                <div class="img-box">
                  <img :src="o" v-if="o"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="cont-mol">
          <p class="tt-1">{{info.softwareSystemName || '--'}}</p>
          <p>{{info.subtitle}}</p>
          <div class="a-mol-1 mt-30">
            <p class="tt-2">价格 <span class="price">¥{{info.standPrice}}</span></p>
            <p class="tt-2 bor-t">使用年限 <span class="col-blue">{{info.useYear}}年</span></p>
            <p v-if="info.tips">温馨提示：{{info.tips}}</p>
            <el-button type="primary" class="p-btn" @click="addToCart">添加到购物车</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="p-cont-mol">
      <p class="tt-3">软件详情</p>
      <div class="p-cont pb-60" v-html="info.systemDetail"></div>
      <CommonProblem :infoList="info.systemProblems"></CommonProblem>
    </div>
  </div>
</template>

<script>
import CommonProblem from './component/commonProblem.vue'
export default {
  name: 'systemDetail',
  components: { CommonProblem },
  data () {
    return {
      query: this.$route.query,
      info: {},
      systemPhoto: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.API.product.getSoftWareSystemDetail({
        softwareSystemUuid: this.query.id
      }).then((res) => {
        let data = res.data || {}
        this.systemPhoto = data.systemPhoto ? data.systemPhoto.split(',') : []
        data.systemProblems = data.systemProblems || []
        this.info = data
      })
    },
    addToCart () {
      let data = localStorage.getItem('prdt')
      data = data ? JSON.parse(data) : []
      let i = _.findIndex(data, { itemType: 'Software', productId: this.info.softwareSystemUuid })
      if (i === -1) {
        data.push({
          itemType: 'Software',
          productId: this.info.softwareSystemUuid,
          productName: this.info.softwareSystemName,
          productNum: 1,
          productPrice: this.info.standPrice,
          productAttribute: [],
          img: this.systemPhoto[0] || ''
        })
        localStorage.setItem('prdt', JSON.stringify(data))
        this.$store.state.cartNum++
      }
      this.$message('已添加到购物车')
    }
  }
}
</script>
